
import {
    Button,
    FormControl,
    FormLabel,
    Textarea,
    VStack,
    HStack,
} from "@chakra-ui/react";
const RatingSelector = ({ label, value, onChange }) => {
    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>

            <HStack flexWrap="wrap">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                    <Button
                        key={num}
                        size="sm"
                        colorScheme={value === num ? "teal" : "gray"}
                        onClick={() => onChange(num)}
                    >
                        {num}
                    </Button>
                ))}
            </HStack>
        </FormControl>
    );
};
export default RatingSelector